var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-4 custom-callout rounded",
      attrs: { "border-color": "primary-2", "has-toggle": false }
    },
    [
      _c("div", { staticClass: "py-1" }, [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c("icon-view", {
              staticClass: "mt-5 mb-2 mt-md-0 mt-sm-5 ml-3",
              attrs: {
                gradient: false,
                icon: "fas fa-file-invoice mb-1",
                "icon-background": "#ffff",
                "icon-color": "#ff7058",
                "icon-size": "16px",
                title: _vm.title
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pl-4" },
          [
            _c("validation-observer", { ref: "studendObserver" }, [
              _c("div", { staticClass: "row my-3" }, [
                _c(
                  "div",
                  { staticClass: "col-md-3 col-sm-12" },
                  [
                    _c("validation-provider", {
                      attrs: {
                        "custom-messages": {
                          required: "El número de SIE es requerido.",
                          studentSie: "El número de SIE no es válido."
                        },
                        rules: "required|studentSie"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-input", {
                                attrs: {
                                  error: errors[0],
                                  label: "Número de Estudiante:",
                                  "mask-type": "SIE",
                                  placeholder: "Escriba número de SIE"
                                },
                                model: {
                                  value: _vm.studentSie,
                                  callback: function($$v) {
                                    _vm.studentSie = $$v
                                  },
                                  expression: "studentSie"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-md-3 col-sm-12 pt-2" }, [
                  _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("action-button", {
                        attrs: {
                          i: "fas fa-search",
                          text: "Buscar",
                          variant: "success pl-3 pr-3 mr-3"
                        },
                        on: { click: _vm.searchStudent }
                      }),
                      !_vm.showStudendSection
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-times-circle",
                              text: "Cancelar",
                              variant: "outline-danger pl-3 pr-3"
                            },
                            on: { click: _vm.onClose }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm.showStudendSection && _vm.student.fullName
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-12 text-bold bold mb-3 mt-2" },
                        [
                          _c("i", {
                            staticClass: "fa fa-info-circle color-orange"
                          }),
                          _vm._v(" Información de Estudiante ")
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-md-12 text-bold bold mb-3 mt-2 pr-5"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "container-student pb-3 pl-3" },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-2 pt-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ml-2 regular text-gray" },
                                      [_vm._v(" Nombre del Estudiante: ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-2 regular color-black"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.student.fullName) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-2 pt-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ml-2 regular text-gray" },
                                      [_vm._v(" SIE: ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-2 regular color-black"
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.studentSie) + " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-2 pt-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ml-2 regular text-gray" },
                                      [_vm._v(" Edad: ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-2 regular color-black"
                                      },
                                      [_vm._v(" " + _vm._s(_vm.getAge) + " ")]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-2 pt-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ml-2 regular text-gray" },
                                      [_vm._v(" Fecha de Nacimiento: ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-2 regular color-black"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("date")(
                                                _vm.student.birthdate
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-2 pt-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ml-2 regular text-gray" },
                                      [_vm._v(" NSS: ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-2 regular color-black"
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.student.ssn) + " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-2 pt-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ml-2 regular text-gray" },
                                      [_vm._v(" Estatus: ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ml-2 regular color-black"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("empty")(
                                                _vm.student.status
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]),
                    _c("hr", { staticClass: "mr-4" }),
                    _c(
                      "validation-observer",
                      { ref: "infoTapRequestObserver" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-2 col-sm-12 mr-md" },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              "custom-error-msg":
                                                "El año académico es requerido.",
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "name",
                                              label: "Año Académico:",
                                              options:
                                                _vm.filters.academicYears,
                                              placeholder: "Seleccione"
                                            },
                                            model: {
                                              value: _vm.academicYear,
                                              callback: function($$v) {
                                                _vm.academicYear = $$v
                                              },
                                              expression: "academicYear"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1721205283
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-3 col-sm-12 mr-md" },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              "custom-error-msg":
                                                "El municipio es requerido.",
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "name",
                                              label: "Municipio de Residencia:",
                                              options:
                                                _vm.filters.municipalities,
                                              placeholder: "Seleccione"
                                            },
                                            model: {
                                              value: _vm.municipality,
                                              callback: function($$v) {
                                                _vm.municipality = $$v
                                              },
                                              expression: "municipality"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2499867326
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-3 col-sm-12 mr-md" },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-drop-down", {
                                            attrs: {
                                              "custom-error-msg":
                                                "La determinación es requerida",
                                              disabled: true,
                                              error: errors[0],
                                              fieldkey: "id",
                                              fieldname: "name",
                                              label: "Determinación:",
                                              options: _vm.filters.requestTypes,
                                              placeholder: "Seleccione"
                                            },
                                            model: {
                                              value: _vm.requestType,
                                              callback: function($$v) {
                                                _vm.requestType = $$v
                                              },
                                              expression: "requestType"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4250156887
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-4 col-sm-12 pt-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "mt-4" },
                                [
                                  _c("action-button", {
                                    attrs: {
                                      i: "fas fa-times-circle",
                                      text: "Cancelar",
                                      variant: "outline-danger mr-3 pl-3 pr-4"
                                    },
                                    on: { click: _vm.onClose }
                                  }),
                                  _c("action-button", {
                                    attrs: {
                                      i: "fas fa-arrow-alt-circle-right",
                                      text: "Continuar",
                                      variant: "success pl-3 pr-3"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onContinue()
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _c("br")
      ]),
      _c(
        "custom-modal",
        {
          attrs: {
            "cancel-text": "No",
            icon: "fas fa-bell-exclamation",
            "is-centered": "",
            "save-text": "Si",
            "show-cancel": false,
            "show-save": false,
            "show-with-shadow": true,
            title: "Confirmación",
            value: _vm.showModal,
            width: "500px"
          }
        },
        [
          _c("div", { staticClass: "container-modal ml-3 mr-3 mt-4 mb-5" }, [
            _vm._v(" El número de consulta ha sido creado con el número "),
            _c("b", [_vm._v(_vm._s(_vm.tapRequestNumber))]),
            _vm._v(
              " favor anotarlo para la creación de la solicitud de reembolso "
            )
          ]),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-copy",
                  text: "Copiar",
                  variant: "success pl-3 pr-3"
                },
                on: {
                  click: function($event) {
                    return _vm.copy()
                  }
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }